import { createAction } from 'redux-actions';
import { actionKey } from '../constants';
import { PapiDeviation } from '@wix/da-papi-types';
import { DurationValue } from '../../_partials/DurationSlider';

export const initialize = createAction(
  `${actionKey}.INITIALIZE`,
  (deviationId: number, username: string, typeId: number) => ({
    deviationId,
    username,
    typeId,
  })
);

export const initializeSuccess = createAction(
  `${actionKey}.INITIALIZE_SUCCESS`,
  (payload: {
    deviation: PapiDeviation;
    tags: string[];
    recommendedTags: string[];
  }) => payload
);

export const initializeError = createAction(
  `${actionKey}.INITIALIZE_ERROR`,
  (errorMessage: string) => ({ errorMessage })
);

export const deinitialize = createAction(
  `${actionKey}.DEINITIALIZE`,
  () => ({})
);

export const setSelectedDuration = createAction(
  `${actionKey}.SET_SELECTED_DURATION`,
  (duration: DurationValue) => ({ duration })
);

// Boost actions are now handled by the existing awardBadge action in coreBadge/redux
